import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

interface IVendas {
  quantidade: number;
  ean: string;
  descricao: string;
  preco: number;
  total: number;
}

async function RelatorioVendasFabrica(dados: IVendas[], nome: string,periodo: string) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  if (dados.length === 0) {
    console.error('Nenhum dado disponível para gerar o relatório.');
    return;
  }        

  // Calcula o total de vendas
  const TValorVendas = dados.reduce((acc, item) => acc + (item.total || 0), 0);

  // Mapeia os dados para criar a tabela
  const vendas = dados.map(({ quantidade, ean, descricao, preco, total }) => [
    { text: quantidade || '-', alignment: 'left', fontSize: 8 },
    { text: ean || '-', alignment: 'left', fontSize: 8 },
    { text: descricao || '-', alignment: 'center', fontSize: 8 },
    { text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(preco || 0), alignment: 'center', fontSize: 8 },
    { text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(total || 0), alignment: 'right', fontSize: 8 },
  ]);

  // Função para converter imagens em base64
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Erro ao obter o contexto 2D');
          return;
        }
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = function () {
        reject(`Erro ao carregar a imagem: ${url}`);
      };
      img.src = url;
    });
  }

  // Carrega a imagem do logo
  const imageUrl = process.env.REACT_APP_URL_IMAGLOG || '';
  let imageData = '';
  try {
    imageData = await getBase64ImageFromUrl(imageUrl);
  } catch (error) {
    console.error('Erro ao carregar a imagem do logo:', error);
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 20, 10],
    pageOrientation: 'portrait',
    header: { text: 'Relatório de Vendas Por Fábrica', alignment: 'center', fontSize: 10, margin: [0, 5, 0, 10] },
    footer: {
      columns: [
        { text: 'Gerado automaticamente', alignment: 'left', fontSize: 8 },
        { text: moment().format('DD/MM/YYYY HH:mm'), alignment: 'right', fontSize: 8 },
      ],
    },
    content: [
      {
        table: {
          widths: [50, '*'],
          body: [
            [
              { image: imageData, width: 80, border: [false, false, false, false] },
              {
                text: 'Relatório de Vendas Por Fábrica',
                fontSize: 20,
                bold: true,
                alignment: 'center',
                margin: [0, 15, 0, 0],
                border: [false, false, false, false],
              },
            ],
          ],
        },
      },
      { text: `Fábrica: ${nome}`, fontSize: 10, margin: [0, 1, 0, 10] },
      { text: `${periodo}`, fontSize: 10, margin: [0, 0, 0, 10] },
      {
        table: {
          widths: [50, 150, 160, 70, 70],
          body: [
            [
              { text: 'Quantidade', alignment: 'left', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'EAN', alignment: 'left', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Descrição', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Valor Unitário', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
              { text: 'Total', alignment: 'center', fillColor: '#dddddd', fontSize: 8, bold: true },
            ],
            ...vendas,
            [
              { text: 'Total Geral:', colSpan: 4, alignment: 'right', bold: true, fontSize: 8 },
              {},
              {},
              {},
              {
                text: new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(TValorVendas),
                alignment: 'right',
                fontSize: 8,
                bold: true,
              },
            ],
          ],
        },
      },
    ],
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.open();
}

export default RelatorioVendasFabrica;
